import React from 'react';
import PropTypes from 'prop-types';
import Mutation from '@dietlabs/components/src/Apollo/Mutation';
import { formatIsoDate, addDays } from 'utils/dateFormatter';
import DayPlanReplaceMealMutation from './DayPlanReplaceMealMutation';
import DayPlanQuery from '../Fetch/DayPlanQuery';
import optimisticResponse from './ReplaceMealOptimisticResponse';

class DayPlanReplaceMealConnectorApollo extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        date: PropTypes.instanceOf(Date).isRequired,
    };

    createReplaceMeal = mutate => async ({ originalMealId, replacementId }) => {
        const variables = {
            request: {
                date: formatIsoDate(this.props.date),
                originalMealId,
                replacementId,
            },
        };

        const response = await mutate({
            variables,
            optimisticResponse,
        });

        return response;
    };

    render() {
        const { children, date } = this.props;

        return (
            <Mutation
                mutation={DayPlanReplaceMealMutation}
                awaitRefetchQueries
                refetchQueries={() => [
                    {
                        query: DayPlanQuery,
                        variables: {
                            date: formatIsoDate(date),
                            canBeCopiedToDate: formatIsoDate(addDays(date, 1)),
                        },
                    },
                ]}
            >
                {mutate =>
                    children({
                        replaceMeal: this.createReplaceMeal(mutate),
                    })
                }
            </Mutation>
        );
    }
}

export default DayPlanReplaceMealConnectorApollo;
